import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '@services/auth';

@Injectable({
	providedIn: 'root'
})
export class LoginPageGuardService implements CanActivate {
	constructor(public authService: AuthService, public router: Router) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authService.isAuthenticatedObserver().pipe(
			map((authenticated: boolean) => {
				// Only allow access to login page if NOT authenticated
				if (!authenticated) return true;

				// If already authenticated, redirect to the app
				this.router.navigate(['/']);

				return false;
			})
		);
	}
}

